import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConstantsService} from '../fidelidade/ConstantsService';

@Component({
  selector: 'app-tela-tabela-precos',
  templateUrl: './tela-tabela-precos.component.html'
})
export class TelaTabelaPrecosComponent implements OnInit {
  empresa: any;
  temModuloTabelaPrecos = false;

  constructor(private constantsService: ConstantsService, private router: Router) { }

  ngOnInit() {
    this.constantsService.empresa$.subscribe((empresa) => {
      this.empresa = empresa;
    });

    this.constantsService.moduloTabelaPrecos$.subscribe((ativo) => {
      this.temModuloTabelaPrecos = !!ativo;
    });
  }

  volteParaProdutos() {
    this.router.navigateByUrl('/admin/produtos');
  }
}
